import { render, staticRenderFns } from "./TecnicoProfile.vue?vue&type=template&id=9116454a"
import script from "./TecnicoProfile.vue?vue&type=script&lang=js"
export * from "./TecnicoProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports